import { render, staticRenderFns } from "./staffleaves.vue?vue&type=template&id=1c084e21&"
import script from "./staffleaves.vue?vue&type=script&lang=js&"
export * from "./staffleaves.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports